/**
 * Filtra médicos atendentes por nome ou especialidade.
 */

import type { AttendedDoctor } from '@/services/chat';

export function filterAttendedDoctors(
  doctors: AttendedDoctor[],
  query: string,
): AttendedDoctor[] {
  const q = query.trim().toLowerCase();
  if (!q) return doctors;

  return doctors.filter((item) => {
    const name = item.doctor?.name?.toLowerCase() ?? '';
    const specialty = item.doctor?.specialty?.toLowerCase() ?? '';
    const email = item.doctor?.email?.toLowerCase() ?? '';
    return name.includes(q) || specialty.includes(q) || email.includes(q);
  });
}

export function conversationAvailabilityLabel(
  availability: AttendedDoctor['conversationAvailability'],
): string {
  switch (availability) {
    case 'available':
      return 'Disponível para conversa';
    case 'doctor_inactive':
      return 'Médico indisponível';
    case 'doctor_unapproved':
      return 'Médico indisponível';
    case 'link_revoked':
      return 'Vínculo encerrado';
    case 'discharged':
      return 'Alta concedida';
    case 'no_thread':
      return 'Sem conversa disponível';
    default:
      return 'Indisponível';
  }
}
